import {
  FETCH_COMPANIES_BY_COUNTRY_START,
  FETCH_COMPANIES_BY_COUNTRY_SUCCESS,
  FETCH_COMPANIES_BY_COUNTRY_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  companiesByCountry: null,
  isFetching: true,
  errorMessage: '',
}

const companiesByCountryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPANIES_BY_COUNTRY_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_COMPANIES_BY_COUNTRY_SUCCESS:
      return {
        ...state,
        companiesByCountry: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_COMPANIES_BY_COUNTRY_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default companiesByCountryReducer
